import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

function titleWithSku(product) {
  return `${product.get("sku")} - ${product.get("title")}`;
}

function convertTitles(products) {
  return products.map(x => {
    return x.set("title", titleWithSku(x))
  });
}

class AdjustStockForm extends Component {

  render() {
    let {errors, handleSubmit, submit, productGroups, products, warehouses, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    let productsWithSkuTitle = convertTitles(products);
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Warehouse"
              name="warehouseId"
              component={DropDownInputField}
              data={warehouses}
              valueKey="id"  
              titleKey="id" 
              showBlank={true}
              serverError={this.props.errors.warehouseId}
              />
            <Field 
              label="Product"
              name="productSku"
              component={DropDownInputField}
              data={productsWithSkuTitle}
              valueKey="sku"  
              titleKey="title" 
              groupKey="type"
              groups={productGroups}
              useGroups={true}
              showBlank={true}
              serverError={this.props.errors.productSku}
              />
            <Field 
              label="Quantity"
              name="quantity"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.quantity}
              />
            <Field 
              label="Reason"
              name="reason"
              component={TextInputField}
              serverError={this.props.errors.reason}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AdjustStockForm"
})(AdjustStockForm);

export default ReduxForm;